export default __webpack_public_path__ + "static/media/hubspot-toolbox.4a315f7e.svg";